import { NgbActiveOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from '@abp/ng.core';
import { CommonModule } from '@angular/common';
import { Component, effect, inject, model, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SupplierOrdersByGroupingKeyDto } from '@digiwall/goliath-documents/proxy';
import { DialogBoxComponent, TableComponent, TableRowComponent } from '@digiwall/ui-kit';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'document-compatible-supplier-order-selection',
  templateUrl: './compatible-supplier-order-selection.component.html',
  imports: [
    CommonModule,
    CoreModule,
    DialogBoxComponent,
    NgSelectModule,
    TableComponent,
    TableRowComponent,
    ReactiveFormsModule,
  ],
})
export class CompatibleSupplierOrderSelectionComponent implements OnInit {
  formBuilder = inject(FormBuilder);
  activeCanvas = inject(NgbActiveOffcanvas);

  selectedSupplierOrderByGroupKey = model<SupplierOrdersByGroupingKeyDto[]>([]);

  form: FormGroup;

  constructor() {
    effect(() => {
      const data = this.selectedSupplierOrderByGroupKey();
      if (data?.length > 0) {
        this.buildForm(data);
      }
    });
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      supplierOrders: this.formBuilder.array([]),
    });
  }

  protected save(): void {
    if (!this.form.valid) return;

    const selectedSupplierOrders = this.form.value.supplierOrders.map((item: any) => ({
      groupKey: item.groupKey,
      supplierOrderId: item.id,
    }));

    this.activeCanvas.close(selectedSupplierOrders);
  }

  private buildForm(data: SupplierOrdersByGroupingKeyDto[]): void {
    this.form = this.formBuilder.group({
      supplierOrders: this.formBuilder.array(
        data.map(item =>
          this.formBuilder.group({
            groupKey: this.formBuilder.group({
              supplierId: [item.groupKey.supplierId],
              customerCode: [item.groupKey.customerCode],
              customerOrderId: [item.groupKey.customerOrderId],
            }),
            id: [item.supplierOrders?.[0]?.id],
          }),
        ),
      ),
    });
  }

  get supplierOrdersArray(): FormArray {
    return this.form.get('supplierOrders') as FormArray;
  }
}
